import { render, staticRenderFns } from "./Advocatura.vue?vue&type=template&id=c09a12d6&lang=pug&"
import script from "./Advocatura.vue?vue&type=script&lang=js&"
export * from "./Advocatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports